import { useEffect, useState } from 'react';
import { api, errMsg } from '../lib/api';

const retrySeconds = error => {
  const advertised = Number(error.response?.headers?.['retry-after']);
  if (advertised > 0) return advertised;
  return [429, 503].includes(error.response?.status) ? 60 : 0;
};

const requestPayload = (purpose, fields, requireCurrentPassword) => {
  const payload = { purpose };
  if (purpose === 'password') payload.password = fields.value;
  else payload.newEmail = fields.value;
  if (requireCurrentPassword) payload.currentPassword = fields.currentPassword;
  return payload;
};

export const useSecurityChange = ({ purpose, basePath, onSuccess, requireCurrentPassword }) => {
  const [fields, setFields] = useState({ currentPassword: '', value: '', repeat: '', code: '' });
  const [challenge, setChallenge] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [resendAt, setResendAt] = useState(0);
  const [tick, setTick] = useState(Date.now());
  const set = (key, value) => setFields(current => ({ ...current, [key]: value }));
  useEffect(() => { const timer = setInterval(() => setTick(Date.now()), 1000); return () => clearInterval(timer); }, []);
  const request = async event => {
    event?.preventDefault();
    if (busy) return;
    setError('');
    if (purpose === 'password' && fields.value !== fields.repeat) { setError('Passwords do not match'); return; }
    setBusy(true);
    try {
      const { data } = await api.post(`${basePath}/request`, requestPayload(purpose, fields, requireCurrentPassword));
      setChallenge(data); set('code', ''); setResendAt(Date.now() + data.resendAfter * 1000);
    } catch (failure) {
      setError(errMsg(failure));
      const retry = retrySeconds(failure);
      if (retry) setResendAt(Date.now() + retry * 1000);
    } finally { setBusy(false); }
  };
  const confirm = async event => {
    event.preventDefault();
    if (busy || !challenge) return;
    setBusy(true); setError('');
    try { const { data } = await api.post(`${basePath}/confirm`, { challengeId: challenge.challengeId, code: fields.code }); await onSuccess(data); }
    catch (failure) { setError(errMsg(failure)); } finally { setBusy(false); }
  };
  return { fields, set, challenge, busy, error, wait: Math.max(0, Math.ceil((resendAt - tick) / 1000)), request, confirm };
};